import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { signin } from '../actions/deliveryActions';
import Loading from '../components/Loading';

export default function DeliveryLoginpage(props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const deliverySignin = useSelector((state) => state.deliverySignin);
  const { loading, deliveryInfo, error } = deliverySignin;
  const dispatch = useDispatch();



  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(signin(email, password));
  };

  return (
    <div>
      <div className='form'>
        <form onSubmit={submitHandler}>
          <ul className='form-container'>
            <li>
              <h2>Delivery Sign-In</h2>
            </li>
            <li>
              {loading && (
                <div>
                  {/* Loading */}
                  <div style={{ padding: '80px' }}>
                      <Loading />
                  </div>
                </div>
              )}
              {error && <div>{error}</div>}
            </li>
            <li>
            <label for="email">Email:</label>
              <input
                required
                name='email'
                id='email'
                onChange={(e) => setEmail(e.target.value)}
              />
            </li>
            <li>
            <label for="password">Password:</label>
              <input
                type='password'
                id='password'
                name='password'
                onChange={(e) => setPassword(e.target.value)}
                
              />
            </li>
            <li>
              <button type='submit' className='button primary'>
                Signin
              </button>
            </li>
          </ul>
        </form>
      </div>
    </div>
  );
}
